/**
 * Utility to perform WMS GetFeatureInfo requests against GeoServer
 * when the user clicks on a WMS overlay layer on the Google Map.
 */

/**
 * Given a Google Map click event, fetch feature info from GeoServer.
 * @param {google.maps.Map} map - The Google Map instance
 * @param {google.maps.LatLng} latLng - The click coordinates
 * @param {string} layer - The WMS layer name (e.g., "cdot:congestionadt")
 * @param {string} geoserverHost - The GeoServer base URL
 * @returns {Promise<Object|null>} - The first feature's properties, or null
 */
export async function getFeatureInfo(map, latLng, layer, geoserverHost) {
    const bounds = map.getBounds();
    const ne = bounds.getNorthEast();
    const sw = bounds.getSouthWest();

    const bbox = `${sw.lng()},${sw.lat()},${ne.lng()},${ne.lat()}`;

    // Calculate the pixel position of the click relative to the map container
    const projection = map.getProjection();
    const topRight = projection.fromLatLngToPoint(ne);
    const bottomLeft = projection.fromLatLngToPoint(sw);
    const clickPoint = projection.fromLatLngToPoint(latLng);

    const scale = Math.pow(2, map.getZoom());
    const mapDiv = map.getDiv();
    const mapWidth = mapDiv.offsetWidth;
    const mapHeight = mapDiv.offsetHeight;

    const x = Math.floor(((clickPoint.x - bottomLeft.x) * scale) / ((topRight.x - bottomLeft.x) * scale) * mapWidth);
    const y = Math.floor(((clickPoint.y - topRight.y) * scale) / ((bottomLeft.y - topRight.y) * scale) * mapHeight);

    const params = [
        "SERVICE=WMS",
        "VERSION=1.1.1",
        "REQUEST=GetFeatureInfo",
        `LAYERS=${layer}`,
        `QUERY_LAYERS=${layer}`,
        "INFO_FORMAT=application/json",
        `SRS=EPSG:4326`,
        `BBOX=${bbox}`,
        `WIDTH=${mapWidth}`,
        `HEIGHT=${mapHeight}`,
        `X=${x}`,
        `Y=${y}`
    ];

    const url = geoserverHost + params.join("&");
    console.log("[WMS GetFeatureInfo] URL:", url);
    console.log("[WMS GetFeatureInfo] Click pixel X:", x, "Y:", y, "Map size:", mapWidth, "x", mapHeight);

    try {
        const response = await fetch(url);
        if (!response.ok) {
            console.error("[WMS GetFeatureInfo] Request failed:", response.status);
            return null;
        }
        const data = await response.json();
        console.log("[WMS GetFeatureInfo] Raw response:", JSON.stringify(data, null, 2));
        if (data.features && data.features.length > 0) {
            console.log("[WMS GetFeatureInfo] Feature properties:", data.features[0].properties);
            return data.features[0].properties;
        }
        console.log("[WMS GetFeatureInfo] No features found at click location");
        return null;
    } catch (err) {
        console.error("[WMS GetFeatureInfo] Error:", err);
        return null;
    }
}
